import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadProducts,
  loadProductsSuccess,
  loadProductsFailure,
  loadCategoriesSuccess,
  loadOccasionsSuccess,
  showLoader,
  hideLoader,

} from './product.action';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { HomeService } from '../../app/pages/home/services/homes/home.service';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

@Injectable()
export class ProductsEffects {
  private actions$ = inject(Actions);
  private service = inject(HomeService);
  private store = inject(Store);

  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProducts),
      tap(() => this.store.dispatch(showLoader())),

      mergeMap(() =>
        this.service.getHomeData().pipe(
          mergeMap((response) => [
            
            loadProductsSuccess({ products: response.products }),
            loadCategoriesSuccess({ categories: response.categories }),
            loadOccasionsSuccess({ occasions: response.occasions }),
            hideLoader()
          ]),
          catchError((error) =>
            of(loadProductsFailure({ error }), hideLoader()),
          )
        )
      )
    )
  );
}
















